import { render, staticRenderFns } from "./CustodyAdd.vue?vue&type=template&id=f56f402a&"
import script from "./CustodyAdd.vue?vue&type=script&lang=js&"
export * from "./CustodyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports